import React from 'react';

import { Checkbox, Grid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { SalesPortalOptionsFormValues } from '../SalesPortalOptionsDrawer';

interface IFormFieldContentRowProps {
  field: string;
  visibleField: string;
  requiredField: string;
  isVisible: boolean;
  isRequired: boolean;
  disabled?: boolean;
  form: UseFormReturnType<SalesPortalOptionsFormValues>;
}

const FormFieldContentRow = ({
  field,
  visibleField,
  requiredField,
  isVisible,
  isRequired,
  form,
  disabled = false,
}: IFormFieldContentRowProps): JSX.Element => {
  const handleChangeVisible = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = e.currentTarget.checked;
    if (!isChecked) {
      form.setFieldValue(requiredField, isChecked);
    }
    form.setFieldValue(visibleField, isChecked);
  };

  const handleChangeRequired = (e: React.ChangeEvent<HTMLInputElement>): void => {
    form.setFieldValue(requiredField, e.currentTarget.checked);
  };

  return (
    <>
      <Grid.Col span={2} offset={1}>
        <Checkbox
          disabled={disabled}
          checked={isVisible}
          {...form.getInputProps(visibleField)}
          onChange={handleChangeVisible}
        />
      </Grid.Col>
      <Grid.Col span={2}>
        <Checkbox
          disabled={disabled || !isVisible}
          checked={isRequired}
          {...form.getInputProps(requiredField)}
          onChange={handleChangeRequired}
        />
      </Grid.Col>
      <Grid.Col span={7}>{field}</Grid.Col>
    </>
  );
};

export default FormFieldContentRow;
